import { Paragraph } from '@tbitop/ui';
import type { OffeneAufgabenStatistikQuery } from '../../infrastructure/graphql/__generated__/objekt-aufgaben-statistik';

type OffeneAufgabenStatistik_offeneAufgabenStatistik = OffeneAufgabenStatistikQuery['offeneAufgabenStatistik'];

type AufgabenstatistikProps = {
  objektAufgabenstatistik: OffeneAufgabenStatistik_offeneAufgabenStatistik;
  className?: string;
};

export const Aufgabenstatistik = ({ objektAufgabenstatistik, className }: AufgabenstatistikProps) => {
  const allObjekteWithOffenAufgaben = objektAufgabenstatistik.anzahlObjekteMitOffenenAufgaben;

  return (
    <Paragraph className={className}>
      {`Offene Aufgaben in ${allObjekteWithOffenAufgaben} Objekt${allObjekteWithOffenAufgaben !== 1 ? 'en' : ''}`}
    </Paragraph>
  );
};
